 
$(document).ready(function () {
 $('.product-slider-main-1').slick({
  centerMode: false,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
    $(".prevbtn-1").click(function () {
		$(".product-slider-main-1").slick("slickPrev");
	});

	$(".nextbtn-1").click(function () {
		$(".product-slider-main-1").slick("slickNext");
	});
	$(".prevbtn-1").addClass("slick-disabled");
	$(".product-slider-main-1").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prevbtn-1").addClass("slick-disabled");
		} else {
			$(".prevbtn-1").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".nextbtn-1").addClass("slick-disabled");
		} else {
			$(".nextbtn-1").removeClass("slick-disabled");
		}
	});
});


 
$(document).ready(function () {
 $('.product-slider-main-2').slick({
  centerMode: false,
  arrows: false,
  slidesToShow: 3,
   slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
    $(".prevbtn-2").click(function () {
		$(".product-slider-main-2").slick("slickPrev");
	});

	$(".nextbtn-2").click(function () {
		$(".product-slider-main-2").slick("slickNext");
	});
	$(".prevbtn-2").addClass("slick-disabled");
	$(".product-slider-main-2").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prevbtn-2").addClass("slick-disabled");
		} else {
			$(".prevbtn-2").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".nextbtn-2").addClass("slick-disabled");
		} else {
			$(".nextbtn-2").removeClass("slick-disabled");
		}
	});
});

 
$(document).ready(function () {
 $('.product-slider-main-3').slick({
  centerMode: false,
  arrows: false,
  slidesToShow: 3,
   slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
    $(".prevbtn-3").click(function () {
		$(".product-slider-main-3").slick("slickPrev");
	});

	$(".nextbtn-3").click(function () {
		$(".product-slider-main-3").slick("slickNext");
	});
	$(".prevbtn-3").addClass("slick-disabled");
	$(".product-slider-main-3").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prevbtn-3").addClass("slick-disabled");
		} else {
			$(".prevbtn-3").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".nextbtn-3").addClass("slick-disabled");
		} else {
			$(".nextbtn-3").removeClass("slick-disabled");
		}
	});
});

 
$(document).ready(function () {
 $('.product-slider-main-4').slick({
  centerMode: false,
  arrows: false,
  slidesToShow: 3,
   slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
    $(".prevbtn-4").click(function () {
    $(".product-slider-main-4").slick("slickPrev");
  });

  $(".nextbtn-4").click(function () {
    $(".product-slider-main-4").slick("slickNext");
  });
  $(".prevbtn-4").addClass("slick-disabled");
  $(".product-slider-main-4").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prevbtn-4").addClass("slick-disabled");
    } else {
      $(".prevbtn-4").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".nextbtn-4").addClass("slick-disabled");
    } else {
      $(".nextbtn-4").removeClass("slick-disabled");
    }
  });
});


 
$(document).ready(function () {
 $('.product-slider-main-5').slick({
  centerMode: false,
  arrows: false,
  slidesToShow: 3,
   slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        arrows: false,
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 630,
      settings: {
        arrows: false,
        centerMode: false,
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
    $(".prevbtn-5").click(function () {
    $(".product-slider-main-5").slick("slickPrev");
  });

  $(".nextbtn-5").click(function () {
    $(".product-slider-main-5").slick("slickNext");
  });
  $(".prevbtn-5").addClass("slick-disabled");
  $(".product-slider-main-5").on("afterChange", function () {
    if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prevbtn-5").addClass("slick-disabled");
    } else {
      $(".prevbtn-5").removeClass("slick-disabled");
    }
    if ($(".slick-next").hasClass("slick-disabled")) {
      $(".nextbtn-5").addClass("slick-disabled");
    } else {
      $(".nextbtn-5").removeClass("slick-disabled");
    }
  });
});

